/**
 * Helper method to ensure that user supplied urls don't include whitespace or a trailing slash.
 *
 * @param url - The URL to clean.
 * @returns The cleaned URL.
 */
export function cleanUrl(url) {
    let newUrl = url;
    // Guard so we don't try to trim something that's not a string
    if (typeof url !== 'string') {
        return url;
    }
    // Trim leading and trailing spaces, but not spaces inside the url
    newUrl = newUrl.trim();
    // Remove the trailing slash to the url if one was included
    if (newUrl[newUrl.length - 1] === '/') {
        newUrl = newUrl.slice(0, -1);
    }
    // Remove the trailing ampersand to the url if one was included
    if (newUrl[newUrl.length - 1] === '&') {
        newUrl = newUrl.slice(0, -1);
    }
    // Remove the trailing questionmark if there is one
    if (newUrl[newUrl.length - 1] === '?') {
        newUrl = newUrl.slice(0, -1);
    }
    // Remove the trailing slash to the url if one was included
    if (newUrl[newUrl.length - 1] === '/') {
        newUrl = newUrl.slice(0, -1);
    }
    // final tidy up
    newUrl = newUrl.trim();
    return newUrl;
}
//# sourceMappingURL=clean-url.js.map